import { TFunction } from "i18next";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DataFieldIndexResource } from "../../../../../../shared/types/dataField";
import { useDataFieldsQuery } from "../../../../shared/api/dataFieldService";
import { ContactAttribute } from "../../../../shared/types";
import { ContactUpdateBaseDiffCard } from "./ContactUpdateBaseDiffCard";
import { useContactAttributeUtils } from "./contactUpdateUtils";

function getHeading(attribute: ContactAttribute, dataFields: DataFieldIndexResource[], t: TFunction) {
	switch (attribute.type) {
		case "column":
		case "relation":
			return t(attribute.entityType);
		case "dataField": {
			const dataField = dataFields.find((d) => attribute.entityType === d.id);
			return dataField?.label || "";
		}
	}
}
interface AttributeCardProps {
	active: boolean;
	attribute: ContactAttribute;
	onClick: () => void;
}

export const ContactUpdateAttributeDiffCard: FC<AttributeCardProps> = ({ active, attribute, onClick }) => {
	const { t } = useTranslation();
	const { data: dataFields } = useDataFieldsQuery();

	const { resolveAttributeValue } = useContactAttributeUtils();

	return (
		<ContactUpdateBaseDiffCard
			active={active}
			heading={getHeading(attribute, dataFields, t)}
			value={resolveAttributeValue(attribute)}
			onClick={onClick}
		/>
	);
};
